module.exports = __webpack_public_path__ + "img/scoreIcon.017e978c.svg";